export type TLink = {
  text: string
  url: string
} & TIcon

export type TIcon = {
  backgroundColor?: TLinkButtonColors
  openInNewTab?: boolean
  fontSize?: string
  iconPosition?: string
  icon?: string
}

export type TLinkView = 'button' | 'text' | 'image'

export type TLinkButtonColors = 'primary' | 'warning' | 'danger' | 'success' | 'black' | 'grey'

export type TLinkButtonColorsStyles = {
  name: TLinkButtonColors
  value: string
}

export type TTextButtonFontSize = 'xxl' | 'xl' | 'lg' | 'base' | 'sm' | 'xs'

export type TTextButtonFontSizeStyles = {
  name: TTextButtonFontSize
  value: string
}

export type TPosition = 'start' | 'end'

export type TIconButtonPositions = {
  name: TPosition
  value: string
}

export const LinkButtonColors: TLinkButtonColorsStyles[] = [
  { name: 'primary', value: 'RichTextEditor__button--primary' },
  { name: 'warning', value: 'RichTextEditor__button--warning' },
  { name: 'danger', value: 'RichTextEditor__button--danger' },
  { name: 'success', value: 'RichTextEditor__button--success' },
  { name: 'black', value: 'RichTextEditor__button--black' },
  { name: 'grey', value: 'RichTextEditor__button--grey' },
]

export const TextButtonFontSize: TTextButtonFontSizeStyles[] = [
  { name: 'xxl', value: 'RichTextEditor__button--fz-xxl' },
  { name: 'xl', value: 'RichTextEditor__button--fz-xl' },
  { name: 'lg', value: 'RichTextEditor__button--fz-lg' },
  { name: 'base', value: 'RichTextEditor__button--fz-base' },
  { name: 'sm', value: 'RichTextEditor__button--fz-sm' },
  { name: 'xs', value: 'RichTextEditor__button--fz-xs' },
]

export const IconButtonPositions: TIconButtonPositions[] = [
  { name: 'start', value: 'start' },
  { name: 'end', value: 'end' },
]
